export const POI_CATEGORIES: Record<string, { color: string; icon: string }> = {
  'ATTRACTIONS - RECREATION': {
    color: '#6365f1',
    icon: 'attractions-recreation-marker.svg'
  },
  'BANKS - FINANCIAL': {
    color: '#9e0059',
    icon: 'banks-financial-marker.svg'
  },
  'EATING - DRINKING': {
    color: '#ff0054',
    icon: 'eating-drinking-marker.svg'
  },
  EDUCATION: {
    color: '#ff5400',
    icon: 'education-marker.svg'
  },
  'GOVERNMENT - PUBLIC': {
    color: '#ffbd00',
    icon: 'government-public-marker.svg'
  },
  'HEALTH CARE SERVICES': {
    color: '#531253',
    icon: 'health-care-services-marker.svg'
  },
  HOSPITALITY: {
    color: '#e2ef70',
    icon: 'hospitality-marker.svg'
  },
  'ORGANIZATIONS - ASSOCIATIONS': {
    color: '#70e4ef',
    icon: 'organizations-associations-marker.svg'
  },
  SHOPPING: {
    color: '#053225',
    icon: 'shopping-marker.svg'
  },
  TRAVEL: {
    color: '#4daa57',
    icon: 'travel-marker.svg'
  }
}
